import React from 'react';

class Products extends React.Component {
    render() {
        return (
            <div id="products" className="section-padding bg-gray">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title wow fadeInDown animated ania" data-wow-delay="0.3s" >Our Products</h2>
                        <p>Our wide experience in the various segments of business and industry give us the in-depth <br />understanding of business operational requirements and parameters.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12">
                            <div className="table wow fadeInLeft animated anib" data-wow-delay="1.2s" >
                                <div className="title">
                                    <h3>Digital Onboard</h3>
                                </div>
                                {/* <div className="pricing-header">
                                    <p className="price-value">$12.90<span>/ Month</span></p>
                                </div>
                                <ul className="description">
                                    <li>Business Analyzing</li>
                                    <li>24/7 Tech Suport</li>
                                    <li>Operational Excellence</li>
                                    <li>Business Idea Ready</li>
                                    <li>2 Database</li>
                                    <li>Customer Support</li>
                                </ul> */}
                                <a className="btn btn-common mt-3" href='/digital-onboard'>View Detail</a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 active">
                            <div className="table wow fadeInUp animated anic" id="active-tb" data-wow-delay="1.2s" >
                                <div className="title">
                                    <h3>Digital Sign</h3>
                                </div>
                                {/* <div className="pricing-header">
                                    <p className="price-value">$49.90<span>/ Month</span></p>
                                </div>
                                <ul className="description">
                                    <li>Business Analyzing</li>
                                    <li>24/7 Tech Suport</li>
                                    <li>Operational Excellence</li>
                                    <li>Business Idea Ready</li>
                                    <li>2 Database</li>
                                    <li>Customer Support</li>
                                </ul> */}
                                <a className="btn btn-common mt-3">View Detail</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Products;


// WEBPACK FOOTER //
// ./src/sections/Products.js